module.exports = __webpack_public_path__ + "static/media/x.4379a044.svg";